import bahasaIcon from "@assets/header/menu/icon/bahasa.svg";
import bahasaSelected from "@assets/header/menu/icon/bahasa-selected.svg";
import dollarIcon from "@assets/header/menu/icon/dollar.svg";
import duniaIcon from "@assets/header/menu/icon/dunia.svg";
import ekoniagaIcon from "@assets/header/menu/icon/ekoniaga.svg";
import ghIcon from "@assets/header/menu/icon/gaya-hidup.svg";
import gengIcon from "@assets/header/menu/icon/gen-g.svg";
import gengIconSelected from "@assets/header/menu/icon/gen-g-white.svg";
import malaysiaIcon from "@assets/header/menu/icon/malaysia.svg";
import podcastIcon from "@assets/header/menu/icon/podcast.svg";
import premiumIcon from "@assets/header/menu/icon/premium.svg";
import singapuraIcon from "@assets/header/menu/icon/singapura.svg";
import sukanIcon from "@assets/header/menu/icon/sukan.svg";
import userIcon from "@assets/header/menu/icon/user.svg";
import videoIcon from "@assets/header/menu/icon/video.svg";
import wacanaIcon from "@assets/header/menu/icon/wacana.svg";
import ghIconSelected from "@assets/header/menu-selected/icon/gaya-hidup.svg";
import malaysiaIconSelected from "@assets/header/menu-selected/icon/malaysia.svg";
import singapuraIconSelected from "@assets/header/menu-selected/icon/singapura.svg";
import mybhIcon from "@assets/header/mybh-logo.svg";
import quickNewsIcon from "@assets/header/newIcons/qn-logo-blue.svg";
import { MYBH_LINK } from "@config/followTopic";
import {
  KAKI_MAKAN_LANDING_PAGE,
  KAKI_MAKAN_REF_CODE_MENU,
} from "@config/kakiMakan";
import {
  EPAPER_LINK,
  VITE_ENABLE_ACARA_SECTION,
} from "@helper/getEnvVariables";

const refParamDesktop = "?ref=nav_bar";
const refParamMobile = "?ref=hamburger-menu";

// Helper function to add ref param to subsection URLs for mobile menu
const addRefToSubsection = (
  subsection: SectionDetails[],
  ref: string,
): SectionDetails[] => {
  return subsection.map((item) => ({
    ...item,
    url: `${item.url}${ref}`,
  }));
};

import {
  DUNIA_SUB_SECTION,
  EKONOMI_SUB_SECTION,
  GAYA_HIDUP_SUB_SECTION,
  NEW_MULTIMEDIA_SUB_SECTION,
  SINGAPURA_SUB_SECTION,
  WACANA_SUB_SECTION,
} from "./subCategoriesConstants";

export type SectionDetails = Readonly<{
  title: string;
  url: string;
  images?: string | undefined;
  newTab?: boolean | undefined;
  selectedColor?: string | undefined;
  selectedIcon?: string | undefined;
  neutralColor?: boolean | undefined;
}>;

export type SectionMobileDetails = Readonly<{
  title: string;
  subtype: string;
  display_format: string;
  limit: number;
  title_clickable: boolean;
  cat_name: string;
}>;

export type SectionMobileAppDetails = Readonly<{
  title: string;
  subtype: string;
  display_format: string;
  limit?: number;
  title_clickable?: boolean;
  cat_name?: string;
  term_name?: string;
  display_name?: string;
  section?: SectionMobile;
}>;

export type SectionMobile = Readonly<{
  code: string;
  name: string;
  feed: string;
  type: string;
  level?: number;
}>;

export const SECTION_LIST_NEW: SectionDetails[] = [
  {
    title: "Terkini",
    url: `/terkini${refParamDesktop}`,
    selectedColor: "blue-400",
  },
  {
    title: "Singapura",
    url: `/singapura${refParamDesktop}`,
    images: singapuraIcon,
    selectedColor: "red-100",
    selectedIcon: singapuraIconSelected,
  },
  {
    title: "Malaysia",
    url: `/malaysia${refParamDesktop}`,
    images: malaysiaIcon,
    selectedColor: "pink-600",
    selectedIcon: malaysiaIconSelected,
  },
  {
    title: "Dunia",
    url: `/dunia${refParamDesktop}`,
    selectedColor: "pink-600",
    images: duniaIcon,
    selectedIcon: duniaIcon,
  },
  {
    title: "Ekonomi",
    url: `/ekonomi-kerja${refParamDesktop}`,
    selectedColor: "green-400",
    images: ekoniagaIcon,
    selectedIcon: ekoniagaIcon,
  },
  {
    title: "Gaya Hidup",
    url: `/gaya-hidup${refParamDesktop}`,
    images: ghIcon,
    selectedColor: "red-600",
    selectedIcon: ghIconSelected,
  },
  {
    title: "Wacana",
    url: `/wacana${refParamDesktop}`,
    selectedColor: "violet-300",
    images: wacanaIcon,
    selectedIcon: wacanaIcon,
  },
  {
    title: "Sukan",
    url: `/sukan${refParamDesktop}`,
    selectedColor: "orange-300",
    images: sukanIcon,
    selectedIcon: sukanIcon,
  },
  {
    title: "Bahasa & Budaya",
    url: `/bahasa-budaya${refParamDesktop}`,
    selectedColor: "pink-500",
    images: bahasaIcon,
    selectedIcon: bahasaSelected,
  },
  {
    title: "Multimedia",
    url: `/videos${refParamDesktop}`,
    selectedColor: "blue-400",
    neutralColor: true,
  },
  {
    title: "Gen G",
    url: `/gen-g${refParamDesktop}`,
    images: gengIcon,
    selectedColor: "blue-150",
    selectedIcon: gengIconSelected,
  },
].filter(Boolean);

export const SECONDARY_SECTION_LIST_NEW: SectionDetails[] = [
  {
    title: "Akses Percuma",
    url: `/akses-percuma${refParamDesktop}`,
    selectedColor: "blue-400",
    images: dollarIcon,
    selectedIcon: dollarIcon,
  },
  {
    title: "Premium",
    url: `/premium-articles${refParamDesktop}`,
    selectedColor: "violet-200",
    images: premiumIcon,
    selectedIcon: premiumIcon,
  },
  {
    title: "Pengguna Berdaftar",
    url: `/registered${refParamDesktop}`,
    selectedColor: "purple-300",
    images: userIcon,
    selectedIcon: userIcon,
  },
  {
    title: "Kuiz BH",
    url: `/kuiz-bh${refParamDesktop}`,
  },
  {
    title: "mata-mata",
    url: "/mata-mata?ref=menu",
    selectedColor: "blue-300",
  },
  {
    title: "Kaki Makan",
    url: `/${KAKI_MAKAN_LANDING_PAGE}${KAKI_MAKAN_REF_CODE_MENU}`,
  },
  {
    title: "Webinar",
    url: `/webinar${refParamDesktop}`,
  },
  {
    title: "BH Services",
    url: `/bh-services${refParamDesktop}`,
  },
  ...(VITE_ENABLE_ACARA_SECTION
    ? [
        {
          title: "Acara",
          url: `/acara${refParamDesktop}`,
        },
      ]
    : []),
].filter(Boolean);

export const MISC_LIST: SectionDetails[] = [
  {
    title: "BHku",
    url: `/${MYBH_LINK}?ref=mybh-menu`,
    images: mybhIcon,
  },
  {
    title: "eNewsletter",
    url: "/ringkasan-berita-harian",
  },
  {
    title: "Sekilas Berita",
    url: "/quick-news?ref=top-menu-quick-news",
  },
  {
    title: "ePaper",
    url: EPAPER_LINK,
    newTab: true,
  },
].filter(Boolean);

export const MISC_LIST_NEW: SectionDetails[] = [
  {
    title: "BHku",
    url: `/${MYBH_LINK}?ref=mybh-menu`,
    images: mybhIcon,
  },
  {
    title: "Sekilas Berita",
    url: "/quick-news?ref=top-menu-quick-news",
    images: quickNewsIcon,
  },
  {
    title: "eNewsletter",
    url: `/ringkasan-berita-harian${refParamDesktop}`,
  },
  {
    title: "ePaper",
    url: `${EPAPER_LINK}${refParamDesktop}`,
    newTab: true,
  },
].filter(Boolean);

export const MOBILE_MAIN_LIST: SectionDetails[] = [
  {
    title: "Kuiz BH",
    url: `/kuiz-bh${refParamMobile}`,
  },
  {
    title: "mata-mata",
    url: "/mata-mata?ref=menu",
  },
  {
    title: "Kaki Makan",
    url: `/${KAKI_MAKAN_LANDING_PAGE}${KAKI_MAKAN_REF_CODE_MENU}`,
  },
  {
    title: "Webinar",
    url: `/webinar${refParamMobile}`,
  },
  {
    title: "BH Services",
    url: `/bh-services${refParamMobile}`,
  },
  ...(VITE_ENABLE_ACARA_SECTION
    ? [
        {
          title: "Acara",
          url: `/acara${refParamMobile}`,
        },
      ]
    : []),
].filter(Boolean);

export const MOBILE_SECTION_LIST: SectionDetails[] = [
  {
    title: "Singapura",
    url: `/singapura${refParamMobile}`,
    images: singapuraIcon,
    selectedColor: "red-100",
    selectedIcon: singapuraIcon,
  },
  {
    title: "Malaysia",
    url: `/malaysia${refParamMobile}`,
    images: malaysiaIcon,
    selectedColor: "pink-600",
    selectedIcon: malaysiaIcon,
  },
  {
    title: "Dunia",
    url: `/dunia${refParamMobile}`,
  },
  {
    title: "Ekonomi",
    url: `/ekonomi-kerja${refParamMobile}`,
  },
  {
    title: "Gaya Hidup",
    url: `/gaya-hidup${refParamMobile}`,
    images: ghIcon,
    selectedColor: "red-600",
    selectedIcon: ghIcon,
  },
  {
    title: "Hidayah",
    url: `/hidayah${refParamMobile}`,
  },
  {
    title: "Wacana",
    url: `/wacana${refParamMobile}`,
  },
  {
    title: "Sukan",
    url: `/sukan${refParamMobile}`,
  },
  {
    title: "Bahasa & Budaya",
    url: `/bahasa-budaya${refParamMobile}`,
    selectedColor: "pink-500",
    images: bahasaIcon,
    selectedIcon: bahasaSelected,
  },
  {
    title: "Podcast",
    url: `/podcasts${refParamMobile}`,
    images: podcastIcon,
    selectedColor: "blue-400",
  },
  {
    title: "Videos",
    url: `/videos${refParamMobile}`,
    images: videoIcon,
    selectedColor: "blue-400",
  },
  {
    title: "Gen-G",
    url: `/gen-g${refParamMobile}`,
  },
];

export const MOBILE_MISC_LIST: SectionDetails[] = [
  {
    title: "Sekilas Berita",
    url: `/quick-news${refParamMobile}`,
  },
  {
    title: "eNewsletter",
    url: `/ringkasan-berita-harian${refParamMobile}`,
  },
  {
    title: "ePaper",
    url: `${EPAPER_LINK}${refParamMobile}`,
    newTab: true,
  },
];

export const MOBILE_SECONDARY_LISTING: SectionDetails[] = [
  {
    title: "Akses Percuma",
    url: `/akses-percuma${refParamMobile}`,
  },
  {
    title: "Premium",
    url: `/premium-articles${refParamMobile}`,
  },
  {
    title: "Pengguna Berdaftar",
    url: `/registered${refParamMobile}`,
  },
];

export const NON_HEADER_NEW: SectionDetails[] = [
  {
    title: "Rencana",
    url: "/rencana",
    selectedColor: "red-200",
  },
  {
    title: "Berita Utama",
    url: "/berita-utama",
    selectedColor: "red-100",
  },
  {
    title: "Kisah Zakat",
    url: "/kisah-zakat",
    selectedColor: "red-100",
  },
  {
    title: "Kesihatan",
    url: "/kesihatan",
    selectedColor: "red-100",
  },
];

export const MOBILE_SECTION_LIST_NEW: Record<string, SectionDetails[]> = {
  Terkini: [
    {
      title: "Terkini",
      url: `/terkini${refParamMobile}`,
      selectedColor: "blue-400",
    },
  ],
  Singapura: addRefToSubsection(SINGAPURA_SUB_SECTION, refParamMobile),
  Malaysia: [
    {
      title: "Malaysia",
      url: `/malaysia${refParamMobile}`,
      selectedColor: "pink-600",
    },
  ],
  Dunia: addRefToSubsection(DUNIA_SUB_SECTION, refParamMobile),
  Ekonomi: addRefToSubsection(EKONOMI_SUB_SECTION, refParamMobile),
  "Gaya Hidup": addRefToSubsection(GAYA_HIDUP_SUB_SECTION, refParamMobile),
  Wacana: addRefToSubsection(WACANA_SUB_SECTION, refParamMobile),
  Sukan: [
    {
      title: "Sukan",
      url: `/sukan${refParamMobile}`,
      selectedColor: "orange-300",
    },
  ],
  "Bahasa & Budaya": [
    {
      title: "Bahasa & Budaya",
      url: `/bahasa-budaya${refParamMobile}`,
      selectedColor: "pink-500",
    },
  ],
  Multimedia: addRefToSubsection(NEW_MULTIMEDIA_SUB_SECTION, refParamMobile),
  "Gen G": [
    {
      title: "Gen-G",
      url: `/gen-g${refParamMobile}`,
      selectedColor: "blue-900",
    },
  ],
};

export const SECTION_LIST_MOBILE_APP: SectionMobileAppDetails[] = [
  {
    title: "Singapura",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Singapura",
    section: {
      code: "singapura",
      name: "singapura",
      feed: "singapura",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Singapura Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Singapura",
  },
  {
    title: "Laporan lain Singapura",
    subtype: "bottom_bar",
    display_format: "SectionFooter",
    display_name: "Laporan lain",
    cat_name: "Singapura",
    section: {
      code: "singapura",
      name: "Singapura",
      feed: "singapura",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Malaysia",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Malaysia",
    section: {
      code: "malaysia",
      name: "Malaysia",
      feed: "malaysia",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Malaysia Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    cat_name: "Malaysia",
  },
  {
    title: "Kaki Jalan",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "Kaki Jalan",
    section: {
      code: "kaki-jalan",
      name: "Kaki Jalan",
      feed: "Kaki Jalan",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "Kaki Jalan Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "Kaki Jalan",
  },
  {
    title: "Kaki Makan",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "Kaki Makan",
    section: {
      code: "kaki-makan",
      name: "Kaki Makan",
      feed: "Kaki Makan",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "Kaki Makan Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "Kaki Makan",
  },
  {
    title: "DNA Dunia Anak",
    subtype: "title_bar",
    display_format: "SectionTitle",
    term_name: "DNA Dunia Anak",
    section: {
      code: "dna-dunia-anak",
      name: "DNA Dunia Anak",
      feed: "DNA Dunia Anak",
      type: "keyword",
      level: 1,
    },
  },
  {
    title: "DNA Dunia Anak Keyword",
    subtype: "articles_by_keyword",
    display_format: "horizontal_list",
    limit: 5,
    title_clickable: true,
    term_name: "DNA Dunia Anak",
  },
  {
    title: "Gaya Hidup",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "Gaya Hidup",
    section: {
      code: "gaya-hidup",
      name: "Gaya Hidup",
      feed: "gaya-hidup",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Gaya Hidup Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Gaya Hidup",
  },
  {
    title: "Laporan lain Gaya Hidup",
    subtype: "bottom_bar",
    display_format: "SectionFooter",
    display_name: "Laporan lain",
    cat_name: "Gaya Hidup",
    section: {
      code: "gaya-hidup",
      name: "Gaya Hidup",
      feed: "gaya-hidup",
      type: "section",
      level: 1,
    },
  },
  {
    title: "Pengguna Berdaftar",
    subtype: "title_bar",
    display_format: "SectionTitle",
    cat_name: "register",
    section: {
      code: "pengguna-berdaftar",
      name: "Pengguna Berdaftar",
      feed: "https://www.beritaharian.sg/registered?mobwebview=true",
      type: "url",
      level: 1,
    },
  },
];

export const SECTION_LIST_MOBILE: SectionMobileDetails[] = [
  {
    title: "Singapura Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Singapura",
  },
  {
    title: "Dunia Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Dunia",
  },
  {
    title: "Wacana Category",
    subtype: "articles_by_category",
    display_format: "vertical_list",
    limit: 3,
    title_clickable: true,
    cat_name: "Wacana",
  },
  {
    title: "Sukan Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Sukan",
  },
  {
    title: "Gaya Hidup Category",
    subtype: "articles_by_category",
    display_format: "horizontal_list",
    limit: 4,
    title_clickable: true,
    cat_name: "Gaya Hidup",
  },
];
